import { render, staticRenderFns } from "./WrapperLink.vue?vue&type=template&id=516fc2ac"
import script from "./WrapperLink.vue?vue&type=script&lang=js"
export * from "./WrapperLink.vue?vue&type=script&lang=js"
import style0 from "./WrapperLink.vue?vue&type=style&index=0&id=516fc2ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports